const initMobMenuBtn = () => {
    const content = document.querySelector('.js-navigation');
    const btns = document.querySelectorAll('.js-nav-btn');

    btns.forEach(btn => {
        btn.addEventListener('click', () => {
            content.classList.toggle('active');
        })
    });
}

initMobMenuBtn()
